import React, { useState, useEffect } from 'react';
import styles from './BedevPlay.module.css';

const BedevPlay = () => {
  const [showAnimation, setShowAnimation] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const categories = [
    { id: 'all', name: 'Todos', icon: '📺' },
    { id: 'frontend', name: 'Frontend', icon: '🎨' },
    { id: 'backend', name: 'Backend', icon: '⚙️' },
    { id: 'mobile', name: 'Mobile', icon: '📱' },
    { id: 'devops', name: 'DevOps', icon: '🚀' },
    { id: 'tutorial', name: 'Tutoriais', icon: '📚' }
  ];

  const videos = [
    {
      id: 1,
      title: 'Introdução ao React.js',
      description: 'Aprenda os fundamentos do React.js e como criar componentes interativos.',
      thumbnail: 'https://img.youtube.com/vi/uG3YS6q1Yzc/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/embed/uG3YS6q1Yzc',
      duration: '15:30',
      category: 'frontend',
      views: '2.1k',
      uploadDate: '2 dias atrás'
    },
    {
      id: 2,
      title: 'Node.js para Iniciantes',
      description: 'Construa APIs robustas com Node.js e Express.',
      thumbnail: 'https://img.youtube.com/vi/KGejVdVpU34/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/embed/KGejVdVpU34',
      duration: '22:45',
      category: 'backend',
      views: '1.8k',
      uploadDate: '5 dias atrás'
    },
    {
      id: 3,
      title: 'CSS Avançado e Animações',
      description: 'Domine técnicas avançadas de CSS e crie animações incríveis.',
      thumbnail: 'https://img.youtube.com/vi/uG3YS6q1Yzc/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/embed/uG3YS6q1Yzc',
      duration: '18:12',
      category: 'frontend',
      views: '3.2k',
      uploadDate: '1 semana atrás'
    },
    {
      id: 4,
      title: 'Docker e Containerização',
      description: 'Aprenda a usar Docker para desenvolver e implantar aplicações.',
      thumbnail: 'https://img.youtube.com/vi/EJdKljdlS60/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/embed/EJdKljdlS60',
      duration: '28:05',
      category: 'devops',
      views: '1.5k',
      uploadDate: '2 semanas atrás'
    },
    {
      id: 5,
      title: 'React Native Fundamentals',
      description: 'Desenvolva apps mobile nativos com React Native.',
      thumbnail: 'https://img.youtube.com/vi/UOaknSZVW10/maxresdefault.jpg',
      videoUrl: 'https://www.youtube.com/embed/UOaknSZVW10',
      duration: '35:20',
      category: 'mobile',
      views: '2.7k',
      uploadDate: '3 semanas atrás'
    }
  ];

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const getVideosByCategory = () => {
    const videosByCategory = {};
    categories.forEach(category => {
      if (category.id === 'all') {
        videosByCategory[category.id] = videos;
      } else {
        videosByCategory[category.id] = videos.filter(video => video.category === category.id);
      }
    });
    return videosByCategory;
  };

  const videosByCategory = getVideosByCategory();

  const openVideoModal = (video) => {
    setSelectedVideo(video);
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
  };

  if (showAnimation) {
    return (
      <div className={styles.animationContainer}>
        <div className={styles.logoAnimation}>
          <span className={styles.bedev}>Be</span>
          <span className={styles.dev}>dev</span>
          <span className={styles.play}>Play</span>
        </div>
        <div className={styles.loadingBar}>
          <div className={styles.loadingProgress}></div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.bedevPlay}>

      <div className={styles.container}>
        <div className={`${styles.sidebar} ${isSidebarCollapsed ? styles.collapsed : ''}`}>
          <div className={styles.sidebarHeader}>
            <h3 className={styles.categoriesTitle}>
              {!isSidebarCollapsed && 'Categorias'}
            </h3>
            <button
              className={styles.collapseButton}
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
              title={isSidebarCollapsed ? 'Expandir categorias' : 'Recolher categorias'}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d={isSidebarCollapsed 
                  ? "M9 18L15 12L9 6" 
                  : "M15 18L9 12L15 6"
                }/>
              </svg>
            </button>
          </div>
          <div className={styles.categories}>
            {categories.map(category => (
              <button
                key={category.id}
                className={`${styles.categoryButton} ${
                  selectedCategory === category.id ? styles.active : ''
                }`}
                onClick={() => setSelectedCategory(category.id)}
                title={category.name}
              >
                {isSidebarCollapsed ? (
                  <span className={styles.categoryIcon}>{category.icon}</span>
                ) : (
                  <span className={styles.categoryName}>{category.name}</span>
                )}
              </button>
            ))}
          </div>
        </div>

        <div className={`${styles.content} ${isSidebarCollapsed ? styles.contentExpanded : ''}`}>
          {selectedCategory === 'all' ? (
            // Mostrar todas as categorias quando "Todos" estiver selecionado
            <>
              {categories.filter(cat => cat.id !== 'all').map(category => {
                const categoryVideos = videosByCategory[category.id];
                if (categoryVideos.length === 0) return null;
                
                return (
                  <div key={category.id} className={styles.categorySection}>
                    <div className={styles.categoryHeader}>
                      <h2 className={styles.categoryTitle}>
                        {category.name}
                      </h2>
                    </div>
                    <div className={styles.videosGrid}>
                      {categoryVideos.map(video => (
                        <div 
                          key={video.id} 
                          className={styles.videoCard}
                          onClick={() => openVideoModal(video)}
                        >
                          <div className={styles.thumbnailContainer}>
                            <img 
                              src={video.thumbnail} 
                              alt={video.title}
                              className={styles.thumbnail}
                            />
                            <div className={styles.playOverlay}>
                              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M8 5V19L19 12L8 5Z"/>
                              </svg>
                            </div>
                            <span className={styles.duration}>{video.duration}</span>
                          </div>
                          <div className={styles.videoInfo}>
                            <h4 className={styles.videoTitle}>{video.title}</h4>
                            <p className={styles.videoDescription}>{video.description}</p>
                            <div className={styles.videoMeta}>
                              <span className={styles.views}>{video.views} visualizações</span>
                              <span className={styles.uploadDate}>{video.uploadDate}</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            // Mostrar apenas a categoria selecionada
            <>
              <div className={styles.contentHeader}>
                <h2 className={styles.sectionTitle}>
                  {categories.find(c => c.id === selectedCategory)?.name}
                </h2>
              </div>
              <div className={styles.videosGrid}>
                {videosByCategory[selectedCategory]?.map(video => (
                  <div 
                    key={video.id} 
                    className={styles.videoCard}
                    onClick={() => openVideoModal(video)}
                  >
                    <div className={styles.thumbnailContainer}>
                      <img 
                        src={video.thumbnail} 
                        alt={video.title}
                        className={styles.thumbnail}
                      />
                      <div className={styles.playOverlay}>
                        <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M8 5V19L19 12L8 5Z"/>
                        </svg>
                      </div>
                      <span className={styles.duration}>{video.duration}</span>
                    </div>
                    <div className={styles.videoInfo}>
                      <h4 className={styles.videoTitle}>{video.title}</h4>
                      <p className={styles.videoDescription}>{video.description}</p>
                      <div className={styles.videoMeta}>
                        <span className={styles.views}>{video.views} visualizações</span>
                        <span className={styles.uploadDate}>{video.uploadDate}</span>
                      </div>
                    </div>
                  </div>
                )) || []}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Video Modal */}
      {selectedVideo && (
        <div className={styles.videoModal} onClick={closeVideoModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeButton} onClick={closeVideoModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            <div className={styles.videoContainer}>
              <iframe
                src={selectedVideo.videoUrl}
                title={selectedVideo.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className={styles.modalVideo}
              ></iframe>
            </div>
            
            <div className={styles.modalInfo}>
              <h3 className={styles.modalTitle}>{selectedVideo.title}</h3>
              <p className={styles.modalDescription}>{selectedVideo.description}</p>
              <div className={styles.modalMeta}>
                <span>{selectedVideo.views} visualizações</span>
                <span>{selectedVideo.uploadDate}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BedevPlay;